<div [class]="classes">
  <ng-content></ng-content>
</div>
